// selectionTrackingPlugin.js
// Plugin to track text selection state and notify external components

import {Plugin, PluginKey} from "prosemirror-state";

export const selectionTrackingKey = new PluginKey("selectionTracking");

/**
 * Create a plugin that tracks text selection and calls a callback
 * @param {Function} onSelectionChange - Callback function (hasSelection: boolean)
 * @returns {Plugin}
 */
export function selectionTrackingPlugin(onSelectionChange) {
    return new Plugin({
        key: selectionTrackingKey,
        state: {
            init(_, state) {
                return {
                    hasSelection: !state.selection.empty
                };
            },
            // apply() is a pure reducer — it must not produce side-effects.
            // We record the new hasSelection value here; the plugin view's
            // update() reads it and fires onSelectionChange after PM commits.
            apply(tr, value, oldState, newState) {
                const hasSelection = !newState.selection.empty;
                if (value.hasSelection === hasSelection) return value;
                return {hasSelection};
            }
        },
        view() {
            let lastHasSelection = null;
            return {
                update(view) {
                    const {hasSelection} = selectionTrackingKey.getState(view.state);
                    if (hasSelection !== lastHasSelection) {
                        lastHasSelection = hasSelection;
                        if (onSelectionChange) {
                            onSelectionChange(hasSelection);
                        }
                    }
                },
            };
        },
    });
}

/**
 * Get the current selection state from the plugin
 * @param {EditorState} state - ProseMirror editor state
 * @returns {Object} { hasSelection: boolean }
 */
export function getSelectionTrackingState(state) {
    return selectionTrackingKey.getState(state);
}

